"use client";
import { useEffect } from "react";
import { motion, stagger, useAnimate } from "framer-motion";
import { cn } from "@/lib/utils";

export const TextGenerateEffect = ({ words, className }: { words: string; className?: string; }) => {
  const [scope, animate] = useAnimate();
  const wordsArray = words.split(" ");

  useEffect(() => {
    animate(
        "span",
        { opacity: 1 },
        { duration: 1, delay: stagger(0.2) }
    ).then(() => {
      animate(
          "span",
          { opacity: 0 },
          { duration: 3, delay: stagger(0.5) }
      );
    });
  }, [animate]); // Only include `animate` in the dependency array

  const renderWords = () => {
    return (
        <motion.div ref={scope}>
          {wordsArray.map((word, idx) => (
              <motion.span key={word + idx} className="dark:text-white text-white opacity-0 text-lg">
                {word}{" "}
              </motion.span>
          ))}
        </motion.div>
    );
  };

  return (
      <div className={cn("font-bold", className)}>
        <div className="mt-4">
          <div className="dark:text-white text-white leading-snug tracking-wide">
            {renderWords()}
          </div>
        </div>
      </div>
  );
};
